// LeadModal.js
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Divider } from 'primereact/divider';

// Load Actions
import * as AppActions from '../../Store/Actions/App'
import * as PartnerActions from '../../Store/Actions/Partner'

import {
	validarCNPJ,
	validarCPF,
	validarEmail,
	validarTelefone,
	validarNome,
	maskCNPJ,
	maskCPF,
	maskPhone,
	isJsonString,
	toJsonOrEmpty,	
} from '../../Components/Utils';

const LeadModal = (props) => {
  const {
    dialog,
    setDialog,
    selectedLead,
    retrieveLead,   // action
  } = props;

  console.log('[selectedLead]--------->]'+JSON.stringify(selectedLead, null, 2));
  console.log('[dialog]--------->]'+JSON.stringify(dialog, null, 2));

  const [loadingData, setLoadingData] = React.useState(true);
  const [lead, setLead] = React.useState(null);

  const closeDialog = () => {
    setDialog('leadModal', false);
    setLead(null);
    setLoadingData(false);
  };

  const statusLabel = (status) => {
    const s = Number(status);
    if (s === 0) return 'Enviado';
    if (s === 1) return 'Visualizado';
    return 'Outro';
  };

  const statusSeverity = (status) => {
    if (Number(status) === 1) return 'success';
    if (Number(status) === 0) return 'warning';
    return 'info';
  };

  const formatBRL = (value) => {
    const v = Number(value || 0);
    return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const executeRetrieveLead = () => {

    if (!selectedLead?.leadId) return;

    setLoadingData(true);

    const actionProps = {
      setLoadingData,
      setSuccess: (data) => {
        setLead(data);
        setLoadingData(false);
      },
      setError: () => {
        setLoadingData(false);
      }
    };

    retrieveLead({ leadId: selectedLead.leadId }, actionProps);
  };

  // Quando abre a modal, busca detalhe
  React.useEffect(() => {
    if (dialog?.target === 'leadModal' && dialog?.status) {
      executeRetrieveLead();
    } else {
      setLead(null);
      setLoadingData(false);
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialog]);

  const footer = (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
      <Button label="Fechar" outlined onClick={closeDialog} />
    </div>
  );

  const data = lead || selectedLead || null;

  const customer = data?.customer || null;
  const customerAddress = data?.customerAddress || null;
  const pricing = data?.pricing || null;
  const sd = data?.serviceOrDiscount || null;
  const targetCustomer = data?.targetCustomer || null;

  return (
    <Dialog
      header="Detalhes do direcionamento"
      visible={dialog?.target === 'leadModal' && dialog?.status}
      style={{ width: '70vw', maxWidth: 1100 }}
      breakpoints={{ '1200px': '92vw', '960px': '96vw' }}
      onHide={closeDialog}
      footer={footer}
      modal
      dismissableMask
    >
      {loadingData ? (
        <div style={{ padding: 20 }}>
          Carregando dados...
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {/* Top summary */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <strong>ID #{data?.leadId || '-'}</strong>
              <small style={{ opacity: 0.7 }}>
                Criado em: {data?.createdAt ? new Date(data.createdAt).toLocaleString('pt-BR') : '-'}
              </small>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <Tag value={statusLabel(data?.status)} severity={statusSeverity(data?.status)} />
              <Tag value={data?.type === 'service' ? 'Serviço' : data?.type === 'discount' ? 'Desconto' : '—'} />
              <Tag value={data?.targetType === 'own' ? 'Próprio' : data?.targetType === 'thirdparty' ? 'Terceiro' : '—'} />
            </div>
          </div>

          <Divider />

          {/* Customer */}
          <div>
            <h4 style={{ margin: '0 0 8px 0' }}>Cliente</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div><strong>Nome:</strong> {customer?.name || '-'}</div>
              <div><strong>CPF:</strong> {maskCPF(customer?.document) || '-'}</div>
              <div><strong>Email:</strong> {customer?.email || '-'}</div>
              <div><strong>Telefone:</strong> {maskPhone(customer?.phone) || '-'}</div>
            </div>
          </div>

          {/* Address */}
          <div>
            <h4 style={{ margin: '10px 0 8px 0' }}>Endereço</h4>
            {!customerAddress ? (
              <div>-</div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <div><strong>Cidade/UF:</strong> {[customerAddress.city, customerAddress.state].filter(Boolean).join(' / ') || '-'}</div>
                <div><strong>CEP:</strong> {customerAddress.zipcode || '-'}</div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <strong>Logradouro:</strong>{' '}
                  {[customerAddress.address, customerAddress.number, customerAddress.complement, customerAddress.neighborhood]
                    .filter(Boolean)
                    .join(', ') || '-'}
                </div>
              </div>
            )}
          </div>

          <Divider />

          {/* Service / Discount */}
          <div>
            <h4 style={{ margin: '0 0 8px 0' }}>Serviço / Desconto</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div><strong>Tipo:</strong> {sd?.type == 'service' ? 'Serviço' : sd?.type == 'discount' ? 'Desconto' : '-'}</div>
              <div><strong>Nome:</strong> {sd?.name || '-'}</div>
            </div>
          </div>

          {/* Pricing */}
          <div>
            <h4 style={{ margin: '10px 0 8px 0' }}>Precificação</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div><strong>Preço do lead:</strong> {formatBRL(pricing?.perLeadPrice)}</div>
              <div><strong>% Desconto:</strong> {pricing?.discountPercentage != null ? `${pricing.discountPercentage}%` : '-'}</div>
              <div><strong>Válido de:</strong> {pricing?.validFrom ? new Date(pricing.validFrom).toLocaleDateString('pt-BR') : '-'}</div>
              <div><strong>Válido até:</strong> {pricing?.validTo ? new Date(pricing.validTo).toLocaleDateString('pt-BR') : '-'}</div>
            </div>
          </div>

          <Divider />

          {/* Target customer (quando thirdparty) */}
          <div>
            <h4 style={{ margin: '0 0 8px 0' }}>Contato informado (Target)</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div><strong>CPF:</strong> {maskCPF(targetCustomer?.document) || '-'}</div>
              <div><strong>Email:</strong> {targetCustomer?.email || '-'}</div>
              <div><strong>Telefone:</strong> {maskPhone(targetCustomer?.phone) || '-'}</div>
              <div><strong>Tipo:</strong> {targetCustomer?.phoneType || '-'}</div>
            </div>
          </div>

          {/* Extras (quando existir no detalhe real) */}
          {Array.isArray(data?.comments) && data.comments.length > 0 && (
            <>
              <Divider />
              <div>
                <h4 style={{ margin: '0 0 8px 0' }}>Comentários</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {data.comments.map((c, idx) => (
                    <div key={idx} style={{ padding: 10, border: '1px solid #eee', borderRadius: 8 }}>
                      <div style={{ fontWeight: 600 }}>{c?.title || 'Comentário'}</div>
                      <div style={{ opacity: 0.8 }}>{c?.comment || c?.message || '-'}</div>
                      <small style={{ opacity: 0.6 }}>{c?.createdAt ? new Date(c.createdAt).toLocaleString('pt-BR') : ''}</small>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </Dialog>
  );
};

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  selectedLead:store.partnerReducer.currentLead,
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...PartnerActions }, dispatch);
export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(LeadModal);	



